import { useState } from "react";
import { wymhFaqs } from "@/mocks/wymh-content";

export default function WymhFaq() {
  const [active, setActive] = useState(0);

  return (
    <section id="wymh-faq" className="wymh-anchor w-full bg-background-100 pt-20 md:pt-24 pb-16 md:pb-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full wymh-halftone opacity-60"></div>
      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-24 text-center lg:text-left">
            <span className="inline-flex items-center gap-2 text-secondary-600 text-sm font-label font-bold tracking-widest mb-4">
              <i className="ri-customer-service-2-line w-4 h-4 flex items-center justify-center"></i>
              读者服务台
            </span>
            <h2 className="wymh-heading text-foreground-950 text-4xl md:text-5xl leading-tight mb-5">
              有问题？
              <br />
              小五来答
            </h2>
            <img
              src="/images/wymh-mascot.png"
              alt="五一漫画吉祥物小五"
              title="五一漫画吉祥物小五"
              className="w-[180px] md:w-[220px] h-auto mx-auto lg:mx-0 object-top mb-5 animate-wymh-float"
            />
            <div className="inline-block px-5 py-3 rounded-2xl rounded-bl-sm bg-primary-500 text-background-50 text-sm font-medium max-w-[240px]">
              点左边的问题，我先替你把答案放出来啦～
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {wymhFaqs.map((faq, index) => {
              const isOpen = active === index;
              return (
                <div
                  key={faq.q}
                  className={`rounded-2xl border bg-background-50 overflow-hidden ${
                    isOpen ? "border-primary-200" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setActive(isOpen ? -1 : index)}
                    className="w-full flex items-center gap-4 px-5 py-5 text-left cursor-pointer"
                  >
                    <span className="shrink-0 w-10 h-10 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-bold">
                      Q
                    </span>
                    <span className="flex-1 text-foreground-950 font-bold text-base md:text-lg">{faq.q}</span>
                    <i
                      className={`${
                        isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-400"
                      } text-xl w-6 h-6 flex items-center justify-center shrink-0`}
                    ></i>
                  </button>

                  {isOpen && (
                    <div className="px-5 pb-6">
                      <div className="flex items-start gap-4">
                        <span className="shrink-0 w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center overflow-hidden">
                          <i className="ri-emotion-happy-line text-xl"></i>
                        </span>
                        <div className="flex-1 rounded-2xl rounded-tl-sm bg-primary-50 border border-primary-100 px-5 py-4">
                          <p className="text-foreground-700 text-sm leading-7">{faq.a}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}